import React from 'react';
import PropTypes from 'prop-types';

import { COMPLETED } from 'constants/new-order-status';
import PodOngoingDetails from './pod-ongoing-details/pod-ongoing-details';
import PodCompletedDetails from './pod-completed-details/pod-completed-details';

const PayOnDeliveryPaymentDetails = ({
  status,
  userType,
  symbol,
  payOnDelivery,
}) => {
  if (status === COMPLETED) {
    return (
      <PodCompletedDetails
        status={status}
        symbol={symbol}
        payOnDelivery={payOnDelivery}
      />
    );
  }

  return (
    <PodOngoingDetails
      status={status}
      userType={userType}
      symbol={symbol}
      payOnDelivery={payOnDelivery}
    />
  );
};

PayOnDeliveryPaymentDetails.propTypes = {
  status: PropTypes.string,
  userType: PropTypes.shape({
    isReceiver: PropTypes.bool,
    isSender: PropTypes.bool,
  }),
  symbol: PropTypes.string,
  payOnDelivery: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        amount: PropTypes.string,
        paymentMethod: PropTypes.string,
      }),
    ),
    totalAmount: PropTypes.string,
    totalCashAmount: PropTypes.string,
    totalCashlessAmount: PropTypes.string,
  }),
};

PayOnDeliveryPaymentDetails.defaultProps = {
  status: '',
  userType: {
    isSender: false,
    isReceiver: true,
  },
  symbol: '',
  payOnDelivery: {
    items: [],
    totalAmount: '',
    totalCashAmount: '',
    totalCashlessAmount: '',
  },
};

export default PayOnDeliveryPaymentDetails;
